import { useMemo } from 'react';

import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks';
import { usePlansTabAccess, useTemplatesTabAccess } from '@/modules/plan/hooks/usePlansAccess';

export const usePlansListVisibility = () => {
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();

  const hasPlansPermissions = usePlansTabAccess();
  const hasTemplatesPermissions = useTemplatesTabAccess();

  const isSubsidiary = useMemo(() => type === OrganizationTypes.subsidiary, [type]);

  const isPlansHiddenByOrgType = useMemo(
    () =>
      type === OrganizationTypes.system ||
      type === OrganizationTypes.partner ||
      type === OrganizationTypes.distributor,
    [type]
  );

  const showPlansTab = !isPlansHiddenByOrgType && hasPlansPermissions;
  const showTemplatesTab = hasTemplatesPermissions;
  const showContent = showPlansTab || showTemplatesTab;

  return {
    showPlansTab,
    showTemplatesTab,
    showContent,
    isSubsidiary,
  };
};
